(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[807],{

/***/ 23646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Anchor; }
});

// UNUSED EXPORTS: isTrivialHref

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCallbackRef.js
var useCallbackRef = __webpack_require__(32092);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useCommittedRef.js
var esm_useCommittedRef = __webpack_require__(92029);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useEventCallback.js
var esm_useEventCallback = __webpack_require__(78146);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useEventListener.js



/**
 * Attaches an event handler outside directly to specified DOM element
 * bypassing the react synthetic event system.
 *
 * @param element The target to listen for events on
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useEventListener_useEventListener(eventTarget, event, listener, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var handler = useEventCallback(listener);
  useEffect(function () {
    var target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
    target.addEventListener(event, handler, capture);
    return function () {
      return target.removeEventListener(event, handler, capture);
    };
  }, [eventTarget]);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useGlobalListener.js



/**
 * Attaches an event handler outside directly to the `document`,
 * bypassing the react synthetic event system.
 *
 * ```ts
 * useGlobalListener('keydown', (event) => {
 *  console.log(event.key)
 * })
 * ```
 *
 * @param event The DOM event name
 * @param handler An event handler
 * @param capture Whether or not to listen during the capture event phase
 */
function useGlobalListener(event, handler, capture) {
  if (capture === void 0) {
    capture = false;
  }

  var documentTarget = useCallback(function () {
    return document;
  }, []);
  return useEventListener(documentTarget, event, handler, capture);
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useInterval.js


/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */

function useInterval(fn, ms, paused, runImmediately) {
  if (paused === void 0) {
    paused = false;
  }

  if (runImmediately === void 0) {
    runImmediately = false;
  }

  var handle;
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  var tick = function tick() {
    if (pausedRef.current) return;
    fnRef.current();
    schedule(); // eslint-disable-line no-use-before-define
  };

  var schedule = function schedule() {
    clearTimeout(handle);
    handle = setTimeout(tick, ms);
  };

  useEffect(function () {
    if (runImmediately) {
      tick();
    } else {
      schedule();
    }

    return function () {
      return clearTimeout(handle);
    };
  }, [paused, runImmediately]);
}

/* harmony default export */ var esm_useInterval = ((/* unused pure expression or super */ null && (useInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useRafInterval.js



function useRafInterval(fn, ms, paused) {
  if (paused === void 0) {
    paused = false;
  }

  var handle;
  var start = new Date().getTime();
  var fnRef = useCommittedRef(fn); // this ref is necessary b/c useEffect will sometimes miss a paused toggle
  // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.

  var pausedRef = useCommittedRef(paused);

  function loop() {
    var current = new Date().getTime();
    var delta = current - start;
    if (pausedRef.current) return;

    if (delta >= ms && fnRef.current) {
      fnRef.current();
      start = new Date().getTime();
    }

    cancelAnimationFrame(handle);
    handle = requestAnimationFrame(loop);
  }

  useEffect(function () {
    handle = requestAnimationFrame(loop);
    return function () {
      return cancelAnimationFrame(handle);
    };
  }, []);
}

/* harmony default export */ var esm_useRafInterval = ((/* unused pure expression or super */ null && (useRafInterval)));
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeState.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



/**
 * Mimics a React class component's state model, of having a single unified
 * `state` object and an updater that merges updates into the existing state, as
 * opposed to replacing it.
 *
 * ```js
 * const [state, setState] = useMergeState({ name: 'Betsy', age: 24 })
 *
 * setState({ name: 'Johan' }) // { name: 'Johan', age: 24 }
 *
 * setState(state => ({ age: state.age + 10 })) // { name: 'Johan', age: 34 }
 * ```
 *
 * @param initialState The initial state object
 */
function useMergeState_useMergeState(initialState) {
  var _useState = useState(initialState),
      state = _useState[0],
      setState = _useState[1];

  var updater = useCallback(function (update) {
    if (update === null) return;

    if (typeof update === 'function') {
      setState(function (state) {
        var nextState = update(state);
        return nextState == null ? state : _extends({}, state, nextState);
      });
    } else {
      setState(function (state) {
        return _extends({}, state, update);
      });
    }
  }, [setState]);
  return [state, updater];
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useMergeStateFromProps.js

function useMergeStateFromProps(props, gDSFP, initialState) {
  var _useMergeState = useMergeState(initialState),
      state = _useMergeState[0],
      setState = _useMergeState[1];

  var nextState = gDSFP(props, state);
  if (nextState !== null) setState(nextState);
  return [state, setState];
}
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/useMounted.js
var useMounted = __webpack_require__(6454);
// EXTERNAL MODULE: ./node_modules/@restart/hooks/esm/usePrevious.js
var usePrevious = __webpack_require__(88833);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useImage.js


/**
 * Fetch and load an image for programatic use such as in a `<canvas>` element.
 *
 * @param imageOrUrl The `HtmlImageElement` or image url to load
 * @param crossOrigin The `crossorigin` attribute to set
 *
 * ```ts
 * const { image, error } = useImage('/static/kittens.png')
 * const ref = useRef<HTMLCanvasElement>()
 *
 * useEffect(() => {
 *   const ctx = ref.current.getContext('2d')
 *
 *   if (image) {
 *     ctx.drawImage(image, 0, 0)
 *   }
 * }, [ref, image])
 *
 * return (
 *   <>
 *     {error && "there was a problem loading the image"}
 *     <canvas ref={ref} />
 *   </>
 * ```
 */
function useImage(imageOrUrl, crossOrigin) {
  var _useState = useState({
    image: null,
    error: null
  }),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    if (!imageOrUrl) return undefined;
    var image;

    if (typeof imageOrUrl === 'string') {
      image = new Image();
      if (crossOrigin) image.crossOrigin = crossOrigin;
      image.src = imageOrUrl;
    } else {
      image = imageOrUrl;

      if (image.complete && image.naturalHeight > 0) {
        setState({
          image: image,
          error: null
        });
        return;
      }
    }

    function onLoad() {
      setState({
        image: image,
        error: null
      });
    }

    function onError(error) {
      setState({
        image: image,
        error: error
      });
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onError);
    return function () {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onError);
    };
  }, [imageOrUrl, crossOrigin]);
  return state;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useIsomorphicEffect.js

var isReactNative = typeof __webpack_require__.g !== 'undefined' && // @ts-ignore
__webpack_require__.g.navigator && // @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
var isDOM = typeof document !== 'undefined';
/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */

/* harmony default export */ var useIsomorphicEffect = (isDOM || isReactNative ? react.useLayoutEffect : react.useEffect);
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/useResizeObserver.js


var targetMap = new WeakMap();
var resizeObserver;

function getResizeObserver() {
  // eslint-disable-next-line no-return-assign
  return resizeObserver = resizeObserver || new window.ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var handler = targetMap.get(entry.target);
      if (handler) handler(entry.contentRect);
    });
  });
}
/**
 * Efficiently observe size changes on an element. Depends on the `ResizeObserver` api,
 * and polyfills are needed in older browsers.
 *
 * ```ts
 * const [ref, attachRef] = useCallbackRef(null);
 *
 * const rect = useResizeObserver(ref);
 *
 * return (
 *  <div ref={attachRef}>
 *    {JSON.stringify(rect)}
 *  </div>
 * )
 * ```
 *
 * @param element The DOM element to observe
 */


function useResizeObserver(element) {
  var _useState = useState(null),
      rect = _useState[0],
      setRect = _useState[1];

  useEffect(function () {
    if (!element) return;
    getResizeObserver().observe(element);
    setRect(element.getBoundingClientRect());
    targetMap.set(element, function (rect) {
      setRect(rect);
    });
    return function () {
      targetMap.delete(element);
    };
  }, [element]);
  return rect;
}
;// CONCATENATED MODULE: ./node_modules/@restart/hooks/esm/index.js














// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(70861);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@restart/ui/esm/Anchor.js
const _excluded = ["onKeyDown"];

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/anchor-has-content */




function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */
const Anchor = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    onKeyDown
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  const [buttonProps] = (0,Button/* useButtonProps */.FT)(Object.assign({
    tagName: 'a'
  }, props));
  const handleKeyDown = (0,esm_useEventCallback/* default */.Z)(e => {
    buttonProps.onKeyDown(e);
    onKeyDown == null ? void 0 : onKeyDown(e);
  });

  if (isTrivialHref(props.href) && !props.role || props.role === 'button') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
      ref: ref
    }, props, buttonProps, {
      onKeyDown: handleKeyDown
    }));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", Object.assign({
    ref: ref
  }, props, {
    onKeyDown: onKeyDown
  }));
});
Anchor.displayName = 'Anchor';
/* harmony default export */ var esm_Anchor = (Anchor);

/***/ }),

/***/ 29123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-services/allied-services",
      function () {
        return __webpack_require__(25226);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79373);
/* harmony import */ var _styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const ErrorComponent = (props)=>{
    const { serverError  } = props;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        function randomNum() {
            "use strict";
            return Math.floor(Math.random() * 9) + 1;
        }
        let increaseTimer = 0;
        const time = 30, selector3 = document.querySelector(".thirdDigit"), selector2 = document.querySelector(".secondDigit"), selector1 = document.querySelector(".firstDigit");
        const loop3 = setInterval(function() {
            "use strict";
            if (increaseTimer > 40) {
                clearInterval(loop3);
                if (selector3) selector3.textContent = serverError ? "5" : "4";
            } else {
                if (selector3) selector3.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop2 = setInterval(function() {
            "use strict";
            if (increaseTimer > 80) {
                clearInterval(loop2);
                if (selector2) selector2.textContent = "0";
            } else {
                if (selector2) selector2.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
        const loop1 = setInterval(function() {
            "use strict";
            if (increaseTimer > 100) {
                clearInterval(loop1);
                if (selector1) selector1.textContent = serverError ? "0" : "4";
            } else {
                if (selector1) selector1.textContent = randomNum().toString();
                increaseTimer++;
            }
        }, time);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "error-component",
        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().error),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-12 text-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().containerError404),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} thirdDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} secondDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().clip),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shadow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().digit)} firstDigit`
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().msg),
                                    children: [
                                        "OH!",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().triangle)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "h1",
                            children: "OOPS, SORRY WE CAN'T FIND THAT PAGE!"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Either something went wrong or the page doesn't exist anymore."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btndiv),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: `${(_styles_Error_module_scss__WEBPACK_IMPORTED_MODULE_3___default().btnPrimary)}`,
                                    children: "Back to home"
                                })
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ErrorComponent);


/***/ }),

/***/ 47046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ MetaTagsComp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59830);





const MetaTagsComp = (props)=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const currentUrl = "https://staging.studies-overseas.com" + (router.asPath || "");
    const { metaTitle , metaDescription , src , keywords , robotsMeta , ogimage , twitterimage , isCustomSchema , schemaJson , jotforms , canonicalUrl , isBlogPage  } = props;
    const structuredJSON = isCustomSchema && schemaJson ? schemaJson : _utils_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultSchema */ .R4;
    const removeQueryParameters = (url)=>{
        const currentUrl = url;
        const queryIndex = currentUrl.indexOf("?");
        return queryIndex !== -1 ? currentUrl.slice(0, queryIndex) : currentUrl;
    };
    const cleanCanonicalUrl = canonicalUrl ? removeQueryParameters(canonicalUrl) : removeQueryParameters(currentUrl);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: metaTitle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: metaDescription
                }),
                keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                robotsMeta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: robotsMeta
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: "Organization"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: ogimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:site_name",
                    content: isBlogPage ? cleanCanonicalUrl : currentUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: cleanCanonicalUrl || canonicalUrl
                }),
                src && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    src: src
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: "@KCOverseasEdu"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: "@KCOverseasEdu"
                }),
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: metaTitle
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: metaDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: twitterimage || "https://www.studies-overseas.com/kc_schema_logo.png"
                }),
                structuredJSON && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    className: "structured-data-list",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredJSON)
                    }
                })
            ]
        })
    });
};


/***/ }),

/***/ 84623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65822);
/* harmony import */ var _styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78409);
/* harmony import */ var _utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3265);
/* harmony import */ var _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90017);










const NeedGuidance = ({ classname , button2Data  })=>{
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const applyCtaButtonProps1 = (0,_utils_applyCtaButtonProps__WEBPACK_IMPORTED_MODULE_3__/* .getOnboardingOrFormCtaProps */ .J)(router, {
        btnLink: button2Data?.link,
        formId: button2Data?.formId,
        toOnboardingEnabled: button2Data?.toOnboardingEnabled,
        sourceUrl:  true ? window.location.pathname : 0
    });
    const ctaBtnClickHandler = (applyCtaButtonProps)=>(e)=>{
            if (applyCtaButtonProps.mode === "onboarding") {
                (0,_utils_b2c_sourceTracking__WEBPACK_IMPORTED_MODULE_4__/* .persistSourceContext */ .jW)({
                    sourceUrl: window.location.href,
                    primarySource: _utils_b2c_constants__WEBPACK_IMPORTED_MODULE_5__/* .PRIMARY_SOURCE_B2C_WIDGET */ .ov,
                    fifthStepVisible: button2Data?.nearestOffice ?? true,
                    coachingVisible: button2Data?.lookingForCoaching ?? true
                });
            }
            applyCtaButtonProps.onClick?.(e);
        };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "need-guidance",
            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studentFooter),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().session),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        style: {
                                            fontSize: "26px"
                                        },
                                        children: "Need guidance? Let us help you."
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().anchor),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "/contact-us",
                                            className: (_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().btTranparent),
                                            children: "Contact Us"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: `${(_styles_NeedGuidance_module_scss__WEBPACK_IMPORTED_MODULE_6___default().enquireBtn)} ${classname || ""} ${applyCtaButtonProps1.formClassName}`,
                                            onClick: button2Data ? ctaBtnClickHandler(applyCtaButtonProps1) : undefined,
                                            children: button2Data?.title ?? "Enquire Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NeedGuidance);


/***/ }),

/***/ 25226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ allied_services; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/AlliedServices.module.scss
var AlliedServices_module = __webpack_require__(95670);
var AlliedServices_module_default = /*#__PURE__*/__webpack_require__.n(AlliedServices_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/NeedGuidance.tsx
var NeedGuidance = __webpack_require__(84623);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/AlliedServicesComponent.tsx












const AlliedServicesComponent = (props)=>{
    const alliedServices = props.pageData;
    const alliedServicesLanding = props.pageDataLanding;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "allied-services",
                className: (AlliedServices_module_default()).aliedServices,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "banner",
                        className: (AlliedServices_module_default()).banner,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (AlliedServices_module_default()).breadcrum,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                            lg: 8,
                                            md: 8,
                                            xs: 12,
                                            className: (AlliedServices_module_default()).centered,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            style: {
                                                                opacity: 0.5
                                                            },
                                                            href: "/",
                                                            children: "Home"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                            href: "",
                                                            children: " Allied Services "
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (AlliedServices_module_default()).abttopContent,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (AlliedServices_module_default()).abttopContentdesk,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                children: alliedServicesLanding?.title
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    " ",
                                                                    alliedServicesLanding?.description
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                                id: "enquirebtn",
                                                                variant: "primary",
                                                                size: "lg",
                                                                className: `${(AlliedServices_module_default()).enquireBannerBtn} btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(alliedServicesLanding?.meta?.jotforms[0]?.jotformid || "241383394530456")}`,
                                                                children: [
                                                                    "  ",
                                                                    alliedServicesLanding?.bannerBtn?.label || "Enquire Now"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (AlliedServices_module_default()).card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (AlliedServices_module_default()).box,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        children: alliedServices?.length > 0 && alliedServices.map((alliedData, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 4,
                                                lg: 4,
                                                md: 6,
                                                sm: 6,
                                                xs: 12,
                                                className: (AlliedServices_module_default()).cardDiv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (AlliedServices_module_default()).webCard,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (AlliedServices_module_default()).eventCardImg,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: alliedData?.card?.img?.url,
                                                                alt: "card-img",
                                                                layout: "responsive",
                                                                width: 370,
                                                                height: 220,
                                                                className: (AlliedServices_module_default()).cardImg
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                            id: "cardBody",
                                                            className: (AlliedServices_module_default()).cardBody,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                                    className: (AlliedServices_module_default()).mainTitle,
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: alliedData?.card?.title
                                                                        }),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: (AlliedServices_module_default()).para,
                                                                    children: alliedData?.card?.description
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (AlliedServices_module_default()).button,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            className: `${(AlliedServices_module_default()).enquirebtn} ${(0,helpers/* isFrappeOrJotFormClass */.gd)(alliedServicesLanding?.meta?.jotforms[0].jotformid)}`,
                                                                            children: "Enquire Now"
                                                                        }),
                                                                        alliedData?.card?.knowMoreLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: alliedData?.card?.knowMoreLink,
                                                                            className: (AlliedServices_module_default()).knowMore,
                                                                            children: "Know more"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, index))
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NeedGuidance/* default */.Z, {
                classname: `${(0,helpers/* isFrappeOrJotFormClass */.gd)(alliedServicesLanding?.meta?.jotforms[0]?.jotformid)}`
            })
        ]
    });
};
/* harmony default export */ var components_AlliedServicesComponent = (AlliedServicesComponent);

// EXTERNAL MODULE: ./components/ErrorComponent.tsx
var ErrorComponent = __webpack_require__(46412);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
;// CONCATENATED MODULE: ./pages/student-services/allied-services.tsx





const AlliedServices = (props)=>{
    const { meta  } = props?.pageDataLanding;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    if (!props.pageData || props.pageData.length === 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AlliedServicesComponent, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var allied_services = (AlliedServices);


/***/ }),

/***/ 95670:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aliedServices":"AlliedServices_aliedServices__XV2ap","banner":"AlliedServices_banner__Ux0F_","abttopContent":"AlliedServices_abttopContent__dTINA","enquireBannerBtn":"AlliedServices_enquireBannerBtn__SN2p7","abttopContentdesk":"AlliedServices_abttopContentdesk__ONaRe","breadcrum":"AlliedServices_breadcrum__65iXb","enquirebtn":"AlliedServices_enquirebtn__IwqD_","heading":"AlliedServices_heading__Pim1G","buttongp":"AlliedServices_buttongp__zDZFy","kcbtn":"AlliedServices_kcbtn__WZACG","centered":"AlliedServices_centered__VxgWg","breadcrumb-item":"AlliedServices_breadcrumb-item__F1f2t","active":"AlliedServices_active__l2Ys6","card":"AlliedServices_card__5VR4l","box":"AlliedServices_box__JFQxl","event__webinar_card":"AlliedServices_event__webinar_card__fapQT","eventCardImg":"AlliedServices_eventCardImg__g4klP","cardImg":"AlliedServices_cardImg__tU91U","sub_title":"AlliedServices_sub_title__PIjfI","main_title":"AlliedServices_main_title__4cImc","cardBody":"AlliedServices_cardBody__7XsdT","mainTitle":"AlliedServices_mainTitle___Tz8u","webCard":"AlliedServices_webCard__iUrSz","para":"AlliedServices_para__BsKJi","button":"AlliedServices_button__sb9t5","knowMore":"AlliedServices_knowMore__Yo_Jf","mobileBlog":"AlliedServices_mobileBlog__nGSKf","webinar_events":"AlliedServices_webinar_events__WRx_Y"};

/***/ }),

/***/ 79373:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__5J6pK","clip":"Error_clip__SVATU","shadow":"Error_shadow__FSdAk","main":"Error_main__RrWpw","digit":"Error_digit__HcJVc","btndiv":"Error_btndiv__gV_0s","btnPrimary":"Error_btnPrimary__RVY52","msg":"Error_msg__ksdYX","triangle":"Error_triangle__qa4xL","containerError404":"Error_containerError404__DhF_F"};

/***/ }),

/***/ 65822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"studentFooter":"NeedGuidance_studentFooter__5o74_","session":"NeedGuidance_session__8Zc7c","anchor":"NeedGuidance_anchor__9XZiq","enquireBtn":"NeedGuidance_enquireBtn__u9ZDM","btTranparent":"NeedGuidance_btTranparent__iNGT9"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ }),

/***/ 78182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Card; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/createWithBsPrefix.js + 1 modules
var createWithBsPrefix = __webpack_require__(66611);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/divWithClassName.js
var divWithClassName = __webpack_require__(39602);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardImg.js




const CardImg = /*#__PURE__*/react.forwardRef( // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({
  bsPrefix,
  className,
  variant,
  as: Component = 'img',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-img');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    className: classnames_default()(variant ? `${prefix}-${variant}` : prefix, className),
    ...props
  });
});
CardImg.displayName = 'CardImg';
/* harmony default export */ var esm_CardImg = (CardImg);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/CardHeaderContext.js
var CardHeaderContext = __webpack_require__(49059);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/CardHeader.js






const CardHeader = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card-header');
  const contextValue = (0,react.useMemo)(() => ({
    cardHeaderBsPrefix: prefix
  }), [prefix]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CardHeaderContext/* default.Provider */.Z.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, prefix)
    })
  });
});
CardHeader.displayName = 'CardHeader';
/* harmony default export */ var esm_CardHeader = (CardHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Card.js








const DivStyledAsH5 = (0,divWithClassName/* default */.Z)('h5');
const DivStyledAsH6 = (0,divWithClassName/* default */.Z)('h6');
const CardBody = (0,createWithBsPrefix/* default */.Z)('card-body');
const CardTitle = (0,createWithBsPrefix/* default */.Z)('card-title', {
  Component: DivStyledAsH5
});
const CardSubtitle = (0,createWithBsPrefix/* default */.Z)('card-subtitle', {
  Component: DivStyledAsH6
});
const CardLink = (0,createWithBsPrefix/* default */.Z)('card-link', {
  Component: 'a'
});
const CardText = (0,createWithBsPrefix/* default */.Z)('card-text', {
  Component: 'p'
});
const CardFooter = (0,createWithBsPrefix/* default */.Z)('card-footer');
const CardImgOverlay = (0,createWithBsPrefix/* default */.Z)('card-img-overlay');
const defaultProps = {
  body: false
};
const Card = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  bg,
  text,
  border,
  body,
  children,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'card');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
    children: body ? /*#__PURE__*/(0,jsx_runtime.jsx)(CardBody, {
      children: children
    }) : children
  });
});
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
/* harmony default export */ var esm_Card = (Object.assign(Card, {
  Img: esm_CardImg,
  Title: CardTitle,
  Subtitle: CardSubtitle,
  Body: CardBody,
  Link: CardLink,
  Text: CardText,
  Header: esm_CardHeader,
  Footer: CardFooter,
  ImgOverlay: CardImgOverlay
}));

/***/ }),

/***/ 49059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
context.displayName = 'CardHeaderContext';
/* harmony default export */ __webpack_exports__["Z"] = (context);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(29123); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);